module.exports = __webpack_public_path__ + "assets/img/16.f7c4d1d9.png";